import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BAND } from "@/data/band";

const go = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Hero() {
  return (
    <section id="home" data-testid="hero" className="relative min-h-screen w-full flex items-end overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${BAND.heroImg})`, backgroundPosition: "center 18%" }}
        aria-hidden
      />
      <div className="absolute inset-0 hero-overlay" aria-hidden />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-8 pb-16 md:pb-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-2 mb-5">
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.2em] text-white/80 bg-white/10 border border-white/15 backdrop-blur-sm rounded-full px-3 py-1.5">
              <MapPin size={13} className="text-[var(--sb-red)]" /> {BAND.location} · Live Rock & Alternative
            </span>
          </div>

          <h1 className="font-display text-white text-glow text-6xl sm:text-7xl md:text-8xl lg:text-9xl leading-[0.9]">
            High-Energy <span className="sb-gradient-text">Live Music</span> That Never Disappoints
          </h1>

          <p className="mt-6 text-lg md:text-xl text-white/85 max-w-2xl leading-relaxed">
            Fronted by a dynamic female vocalist and built from established Scottish musicians —
            Songbird delivers exhilarating, unforgettable shows rooted in rock & alternative,
            with the pulse of pop and dance.
          </p>

          <p className="mt-4 font-display text-2xl md:text-3xl text-[var(--sb-amber)] tracking-wide">
            {BAND.tagline}
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <Button
              data-testid="hero-book-btn"
              onClick={() => go("contact")}
              className="h-14 px-8 text-base bg-[var(--sb-red)] hover:bg-[#ff4545] text-white font-bold uppercase tracking-wider rounded-full glow-red group"
            >
              Book the Band
              <ArrowRight size={20} className="ml-1 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              data-testid="hero-notify-btn"
              onClick={() => go("contact")}
              variant="outline"
              className="h-14 px-8 text-base bg-white/5 border-white/30 hover:bg-white/15 text-white font-bold uppercase tracking-wider rounded-full backdrop-blur-sm"
            >
              Get Notified
            </Button>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex items-end gap-1 h-8 opacity-70" aria-hidden>
        {[0, 1, 2, 3, 4].map((i) => (
          <span key={i} className="eq-bar" style={{ animationDelay: `${i * 0.12}s` }} />
        ))}
      </div>
    </section>
  );
}
